import {useQuery, UseQueryResult} from "react-query";
import {getAllTypeRapport} from "./typeRapport.services";

export const useGetAllTypeRapport = ():UseQueryResult<TypeRapport[], Error>=>{
    return useQuery<TypeRapport[], Error>(["type_rapports"], getAllTypeRapport)
}